import Hero from "./components/Hero";
import SkinConcerns from "./components/SkinConcerns";
import Programs from "./components/Programs";
import WhyUs from "./components/WhyUs";
import Process from "./components/Process";
import Effects from "./components/Effects";
import Testimonials from "./components/Testimonials";
import CTA from "./components/CTA";
import FAQ from "./components/FAQ";

export default function Home() {
  return (
    <>
      <Hero />
      <SkinConcerns />
      <Programs />
      <WhyUs />
      <Process />
      <Effects />
      <Testimonials />
      <CTA />
      <FAQ />
    </>
  );
}